<template>
  <div class="contain">
    <h4 class="title">会议详情</h4>
    <el-card>
      <div class="mianMessage">
        <div class="profile">
          <img
            src="../../assets/image/avater.png"
            alt=""
          />
        </div>
        <div class="line"></div>
        <div class="intro">
          <h4>共识的会议</h4>
          <p class="position">
            <span>会议类别:其他</span>
            <span>呼吸科</span>
            <span>主任医师</span>
          </p>
          <p class="meetingdata">
            会议时间：2022-01-23 15:33:22-2022-01-23 15:33:22
          </p>
        </div>
      </div>
    </el-card>
    <el-card class="el-cards">
      <div class="l_1 left1">
        <div class="groups">
          <h5>参会专家</h5>
          <p>孙晓宇 李思慧 王小源</p>
        </div>
        <div class="groups">
          <h5>会议形式</h5>
          <p>线上</p>
        </div>
        <div class="groups">
          <h5>线上</h5>
          <p>线上</p>
        </div>
        <div class="groups">
          <h5>是否准备PPT</h5>
          <p>无PPT</p>
        </div>
      </div>
      <div class="l_1 left2">
        <div class="groups">
          <h5>是否准备PPT</h5>
          <p>无PPT</p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    color: #212529;
    font-size: 28px;
    padding-bottom: 21px;
    border-bottom: 1px solid #e8e8e8;
  }
  .el-card {
    margin-top: 23px;
    .mianMessage {
      display: flex;
      .profile {
        width: 119px;
        height: 119px;
        overflow: hidden;
        border-radius: 50%;
        img {
          width: 100%;
        }
      }
      .line {
        width: 1px;
        min-height: 173px;
        background-color: #e4e4e4;
        margin-left: 26px;
      }
      .intro {
        margin-left: 21px;
        h4 {
          color: #212529;
        }
        .position {
          margin-top: 8px;
          span {
            display: inline-block;
            margin-right: 35px;
            color: #9a9b9d;
          }
        }
        .meetingdata {
          font-size: 13px;
          color: #212529;
          margin-top: 80px;
        }
      }
    }
  }
  .el-cards {
    flex: 1;
    /deep/.el-card__body {
      display: flex;
      height: 100%;
      justify-content: space-between;
    }
    .l_1 {
      width: 48%;
      height: 100%;
      border: 1px solid #f0f0f0;
      padding: 0 25px;
      h5 {
        color: #212529;
        font-size: 16px;
      }
      p {
        color: #212529;
        font-size: 13px;
        margin-top: 23px;
      }
    }
    .left1 {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .left2 {
      .groups {
        margin-top: 23px;
      }
    }
  }
}
</style>
